import type { OrderRepository } from '../../domain/repositories/OrderRepository';

export class DownloadOrderItemUseCase {
  constructor(private readonly repository: OrderRepository) {}

  async execute(downloadUrl: string): Promise<void> {
    return this.repository.downloadItem(downloadUrl);
  }
}
